import themes from 'devextreme/ui/themes';
import { enableProdMode, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';
import { AuthService, ScreenService, AppInfoService, ThemeService } from './app/services';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { DxHttpModule } from 'devextreme-angular/http';
import { PlanningTaskListModule } from './app/pages/planning-task-list/planning-task-list.component';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Router } from '@angular/router';

config({ licenseKey });

if (environment.production) {
  enableProdMode();
}

export function initializeApp(authService: AuthService) {
  return () => authService.getUser();
}

themes.initialized(() => {
  bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(BrowserModule, DxHttpModule, PlanningTaskListModule, AppRoutingModule),
      provideAppInitializer(() => {
        const initializerFn = (initializeApp)(inject(AuthService));
        return initializerFn();
      }),
      AuthService,
      ScreenService,
      AppInfoService,
      ThemeService
    ]
  }).catch((err) => console.error(err));
});
